/**
 * Settings module translations - Labels section
 */

const labels = {
  peppolNumber: "Número Peppol",
  enterPeppolNumber: "Ingrese el número Peppol",
  taxId: "ID fiscal",
  enterTaxId: "Ingrese el ID fiscal",
  country: "País",
  enterCountry: "Ingrese su país",
  language: "Idioma",
  selectLanguage: "Seleccionar idioma...",
  languageForPDFs: "Idioma para PDFs",
  others: "Otros",
  active: "Activo",
  companyName: "Nombre de la empresa",
  products: "Productos",
  ksefToken: "Token KSeF",
  ksefTokenShow: "Mostrar token",
  ksefTokenHide: "Ocultar token",
  editLanguageForPDFs: "Editar idioma para PDFs",
  setLanguageForPDFs: "Establecer idioma para PDFs",
  deleteCountry: "Eliminar país",
  deleteCountryConfirmation: "¿Está seguro de que desea eliminar el país",
  changePeppolStatus: "Cambiar estado de Peppol",
  editPeppolVerification: "Editar verificación de Peppol",
  applyForPeppolNumber: "Solicitar número Peppol",
  completeRegistrationProcess: "Complete el proceso de registro en 4 pasos simples",
  companyInformation: "Información de la empresa",
  attachIdentityDocument: "Adjuntar documento de identidad",
  downloadDocument: "Descargar documento",
  uploadSignedDocument: "Subir documento firmado",
  selectStatus: "Seleccionar estado",
  chooseStatus: "Elegir estado...",
  rejectionNotes: "Notas de rechazo",
  enterRejectionReason: "Ingrese la razón del rechazo...",
  approved: "Aprobado",
  rejected: "Rechazado",
  uploadRequiredDocuments: "Por favor, suba los documentos requeridos para la verificación de Peppol. Puede subir un máximo de 1-2 archivos.",
  identityFile: "Archivo de identidad",
  agreementFile: "Archivo de acuerdo",
  uploadIdentityFile: "Subir archivo de identidad",
  uploadAgreementFile: "Subir archivo de acuerdo",
  uploadedFiles: "Archivos subidos:",
  invalidFileFormat: "Formato de archivo inválido. Solo se permiten archivos JPEG, JPG, PNG y PDF.",
  selectAtLeastOneFile: "Por favor, seleccione al menos un archivo para subir",
  changeStatus: "Cambiar estado",
  addVatNumber: "Agregar número de IVA",
  selectCountry: "Seleccionar país",
  selectDate: "Seleccionar fecha",
  typeOfActivity: "Tipo de actividad",
  nexusEstablished: "Nexus establecido",
  validFrom: "Válido desde",
  validTill: "Válido hasta",
  notUsedForInvoice: "Este número <strong>no se utilizará</strong> para L'Invoice",
  reasonForRegistration: "Motivo de registro",
  sku: "SKU",
  description: "Descripción",
  classificationCode: "Código de clasificación",
  classificationCodeWithCountry: "Código de clasificación de {{countryName}}",
  searchClassificationCode: "Escriba el código o la descripción para buscar…",
  noMatches: "No hay coincidencias"
};

export default labels;
